import { useMemo, useState } from "react";
import { useApolloClient } from "@apollo/client";

import { useAppDispatch, useAppSelector } from "../../../Store";

import { PanelBasicQueryInfoInput, FeedComponentsResponse, GET_FEED_COMPONENTS_INFO } from "./GQLCalls/getFeedComponentsCall";
import { MAINTAIN_FEED_COMPONENTS_INFO } from "./GQLCalls/updateFeedComponents";
import { gqlActions } from "../gqlData_Reducer";
import { FeedComponentItem } from "./FeedDataSlices/feedComponentsSlice";
import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { noop } from "lodash";
import { filterByConnection } from "../filterByConnection";
import { TestData } from "../../../Assets/TestData/componentsData";

export const useFeedComponents = (connection: Graph_QL.GQLCons): GqlHook_Returns<FeedComponentItem, PanelBasicQueryInfoInput> => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [cursorId, setCursorId] = useState(-1);

  const feedComponentsState = useAppSelector(({graphQlData:{domain}}) => domain.feedComponents);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(feedComponentsState, Graph_QL.ToArr(connection)) as Record<string, FeedComponentItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<FeedComponentItem>)
  },[connection, feedComponentsState]);

  const getFeedComponentsInfo = async (specific?: Graph_QL.GQLCons, input?: PanelBasicQueryInfoInput) => {
    try {
    await client.query<FeedComponentsResponse>({query: GET_FEED_COMPONENTS_INFO, variables: {...specific?.connection, input}})
      .then((e) => {
        if (e && e.data) {
          dispatch({type: String(gqlActions.domain.feedComponents.add), payload: {con: connection?.connection, data: e.data.feedComponentsInfo}});
          setCursorId(e.data.feedComponentsInfo.at(-1)?.id ?? -1)
        }
      })}
      catch {
         dispatch({type: String(gqlActions.domain.feedComponents.add), payload: {con: connection?.connection, data: TestData}}); 
         // TODO CTO This is only for when graphql fails currently the test data should never be populated in production
      }
    }
  
  const fetchMore = async (cursor: number|number[], specific?: Graph_QL.GQLCons) => {
    // TODO This used to work but changes to the query when it was implemented with sql connection have changed it.
    // await client.query<FeedComponentsResponse>({query: GET_FEED_COMPONENTS_INFO, variables: {domain: cursorId, fetchMore: 50}})
    //   .then((e) => {
    //     if (e && e.data) {
    //       dispatch({type: String(gqlActions.domain.feedComponents.maintained), payload: {con: connection?.connection, data: e.data.feedComponentsInfo}});
    //       setCursorId(e.data.feedComponentsInfo.at(-1)?.id ?? -1);
    //     }
    //     if (e.error) {
    //       return
    //     }
    //   })
    }

  const maintainEntries = async (changedData?: Partial<FeedComponentItem>) => {
    
    const typeGuardedChangedData = {
      con: changedData?.con,
      data: changedData?.data?.map((info) => {
        return {
          ...info,
          priority: +info.priority,
          ds: +info.ds,
          energy: +info.energy,
          protein: +info.protein
        }
      })
    }
    try {
      await client.mutate({mutation: MAINTAIN_FEED_COMPONENTS_INFO, variables: {...connection.connection, maintainFeedComponents: typeGuardedChangedData?.data}})
      .then((e) => {
        if (e && e.data) {
         dispatch({type: String(gqlActions.domain.feedComponents.maintained), payload: {con: connection?.connection, data: e.data.panelMaintainFeedComponents.updatedValues}});
        }
      })
    } catch {
      console.warn("The update failed -> no changes dispatched")
    }
  }

  return {call: getFeedComponentsInfo, fetchMore, deleteEntries: noop, data: fullState, maintainEntries}
} 

